import React from 'react';
import { makeStyles, Theme, useTheme } from '@lifeomic/chroma-react/styles';
import ReactJson from 'react-json-view';
import { Paper } from '@lifeomic/chroma-react/components/Paper';
import { Text } from '@lifeomic/chroma-react/components/Text';

const useStyles = makeStyles((theme: Theme) => ({
  viewerContainer: {
    width: '100%',
    padding: 8,
    overflowY: 'auto',
  },
  bottomPadding: {
    marginBottom: theme.spacing(1),
  },
}));

interface JsonViewerProps {
  label: string;
  resource: fhir.Resource;
}

const JsonViewer: React.FC<JsonViewerProps> = ({ label, resource }) => {
  const classes = useStyles({});
  const theme = useTheme();

  return (
    <div className={classes.viewerContainer}>
      <Paper fullWidth>
        <Text className={classes.bottomPadding}>{label}</Text>
        <ReactJson
          src={resource}
          style={{ fontFamily: theme.typography.fontFamily }}
          displayDataTypes={false}
          displayObjectSize={false}
        />
      </Paper>
    </div>
  );
};

export default React.memo(JsonViewer);
